import React, { Component } from "react";
import { inject, observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';

import { PageWrapper } from "components/PageWrapper";
import { Question } from "../components/Question";

import HttpClient from 'services/HttpClient';

const MCQ_QUESTIONS_API = '/api/v1/mcq_questions';
const MCQ_THEMES_API = '/api/v1/themes';

@withRouter
@inject('mcqThemesStore')
@inject('mcqQuestionsStore')
@observer
class McqQuestions extends Component {
  constructor() {
    super();

    this.state = {
      totalPages: 1,
    };
  }

  componentDidMount() {
    const { mcqQuestionsStore, mcqThemesStore } = this.props;

    new HttpClient().get(`${MCQ_QUESTIONS_API}?page=1&per_page=10`)
    .then(({body}) => {
      mcqQuestionsStore.setQuestions(body.data.questions);

      this.setState({
        totalPages: body.data.total_pages,
      });
    });
    new HttpClient().get(MCQ_THEMES_API)
    .then(({ body }) => {
      mcqThemesStore.setMcqThemes(body.data.theme);
    });
  }

  nextQuestions = page => {
    const { mcqQuestionsStore } = this.props;

    new HttpClient().get(`${MCQ_QUESTIONS_API}?page=${page.selected + 1}&per_page=10`).then(({body}) => {
      mcqQuestionsStore.setQuestions(body.data.questions);

      this.setState({
        totalPages: body.data.total_pages,
      });
      window.scrollTo({top: 0});
    });
  };

  handleAddQuestion = () => {
    const { mcqQuestionsStore } = this.props;

    const questions = [...mcqQuestionsStore.questions, {
      question: '',
      key_learnings: '',
      explanation: '',
      options: [{
        body: '',
        correct: false,
      }],
      theme_ids: [],
    }];

    mcqQuestionsStore.setQuestions(questions);
  };

  render() {
    const { mcqThemesStore: { mcq_themes }, mcqQuestionsStore: { questions } } = this.props;
    const { totalPages } = this.state;

    return (
      <PageWrapper>
        <div className="page-container">
          <h2>MCQ Question</h2>
        </div>
        <Link
          className="btn-new-main"
          to="/mcq-questions/add"
        >
          Add Question
        </Link>
        <div className="row">
          <div className="container mcq-questions-list">
            {questions.map(question => (
              <Question
                key={`questions_list_${question.id}`}
                question={question}

              />
            ))}
          </div>
        </div>
        <div className="pagination-container">
          <ReactPaginate
            containerClassName="react-paginate"
            pageCount={totalPages}
            onPageChange={this.nextQuestions}
          />
        </div>
      </PageWrapper>
    );
  }
};

export default McqQuestions;



// WEBPACK FOOTER //
// ./src/modules/admin/mcqQuestions/containers/McqQuestions.js